import { ReactElement } from 'react'
import { Button, Stack } from '@mui/material'
import { Form2, SubmitButton, TextField } from '@ui/forms'
import { aiInstructionSchema, type AIInstructionFormValues } from '../schema'

interface Props {
  id: string
  defaultText?: string
  submitText: string
  isLoading: boolean
  onSubmit: (text: string) => Promise<unknown>
  onCancel?: () => void
  'data-cy'?: string
}

/** One multiline text field to add or edit a single KI-Instruktion. */
const AIInstructionForm = ({
  id,
  defaultText = '',
  submitText,
  isLoading,
  onSubmit,
  onCancel,
  'data-cy': dataCy,
}: Props): ReactElement => (
  <Form2<AIInstructionFormValues>
    id={id}
    data-cy={dataCy}
    defaultValues={{ text: defaultText }}
    validationSchema={aiInstructionSchema}
    onSubmit={values => onSubmit(values.text.trim())}
  >
    <Stack spacing={1}>
      <TextField
        name="text"
        multiline
        rows={3}
        placeholder="z. B. Decken immer als Rippendecken mit Nadelholz C24 modellieren."
        autoFocus={!!onCancel}
        data-cy="ai-instruction-text"
      />
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        {onCancel && (
          <Button size="small" onClick={onCancel} data-cy="ai-instruction-cancel">
            Abbrechen
          </Button>
        )}
        <SubmitButton
          loading={isLoading}
          fullWidth={false}
          text={submitText}
          data-cy="ai-instruction-submit"
        />
      </Stack>
    </Stack>
  </Form2>
)

export default AIInstructionForm
